import * as dataStore from './DataStore';
import ReadingLevel from '../models/ReadingLevel';

/**
 * @returns a ReadingLevel object
 */
export function getLexile() {
	const lexile = dataStore.getJsonData().FeatureContent.LexileInfo;
	if (lexile) {
		return new ReadingLevel(lexile);
	}
}




// WEBPACK FOOTER //
// ./src/data/ReadingLevelSelector.js